import styled from 'styled-components';

export const ShopContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 24px;
  background: #fff;
`;

export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
`;

export const ProductCard = styled.div`
  background: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  transition: transform 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    background: rgb(255, 219, 219);
  }
`;

export const ProductImage = styled.div`
  width: 100%;
  padding-top: 100%; /* 1:1 Aspect Ratio */
  background: #e0e0e0;
  position: relative;
  overflow: hidden;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ProductInfo = styled.div`
  padding: 16px;
`;

export const ProductTitle = styled.h3`
  margin: 0;
  font-size: 1.2rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const ProductPrice = styled.p`
  margin: 8px 0 0;
  font-size: 1.1rem;
  color: #c41e3a;
  font-weight: 500;
`;

export const ShopHeader = styled.div`
  max-width: 1400px;
  margin: 0 auto 32px;
  text-align: center;
`;

export const ShopTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  color: #000;
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;

export const Watermark = styled.div`
  position: fixed;
  bottom: -1rem;
  left: 2rem;
  font-size: 8vw;
  font-weight: bold;
  color: rgba(196, 30, 58, 0.05);
  z-index: 0;
  animation: float 6s ease-in-out infinite;

  @keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-20px); }
    100% { transform: translateY(0px); }
  }
`; 